import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

const BASE_URL = `helios-sessions`
export const RECON_DATE_URL = `${BASE_URL}/currentReconDate`

@Injectable({
  providedIn: 'root',
})
export class HttpSessionsService {
  constructor(private readonly http: HttpClient) {}

  getReconDate(): Promise<string> {
    return this.http.get(RECON_DATE_URL, { responseType: 'text' }).toPromise()
  }
}
